// Comprehensive city database with coordinates for AfriMarket location-first
// navigation. Format per row: [name, latitude, longitude, areas?]
//
// "areas" only present for cities with sub-area pages (e.g. London → Peckham).
// Slugs are derived at runtime from name (lowercase, hyphenated, ASCII-folded).

export const CITIES_BY_COUNTRY = {
  // ── NIGERIA — 36 state capitals + major commercial cities ─────────────────
  nigeria: [
    ["Lagos", 6.5244, 3.3792, ["Ikeja","Lekki","Victoria Island","Ikoyi","Yaba","Surulere","Ajah","Apapa","Festac","Ojo","Mushin","Oshodi","Agege","Alimosho","Epe"]],
    ["Abuja", 9.0765, 7.3986, ["Wuse","Garki","Maitama","Asokoro","Gwarinpa","Kubwa"]],
    ["Kano", 12.0022, 8.5920], ["Ibadan", 7.3776, 3.9470], ["Port Harcourt", 4.8156, 7.0498],
    ["Benin City", 6.3350, 5.6037], ["Kaduna", 10.5222, 7.4383], ["Maiduguri", 11.8333, 13.1500],
    ["Zaria", 11.0667, 7.7000], ["Aba", 5.1067, 7.3667], ["Jos", 9.8965, 8.8583],
    ["Ilorin", 8.5000, 4.5500], ["Oyo", 7.8500, 3.9300], ["Enugu", 6.4528, 7.5483],
    ["Abeokuta", 7.1475, 3.3619], ["Onitsha", 6.1450, 6.7860], ["Warri", 5.5167, 5.7500],
    ["Sokoto", 13.0667, 5.2333], ["Calabar", 4.9500, 8.3250], ["Katsina", 12.9889, 7.6028],
    ["Akure", 7.2500, 5.1950], ["Bauchi", 10.3158, 9.8442], ["Ado-Ekiti", 7.6219, 5.2211],
    ["Owerri", 5.4836, 7.0333], ["Minna", 9.6139, 6.5569], ["Asaba", 6.1980, 6.7330],
    ["Uyo", 5.0500, 7.9333], ["Yola", 9.2333, 12.4833], ["Makurdi", 7.7333, 8.5333],
    ["Lokoja", 7.8000, 6.7333], ["Damaturu", 11.7444, 11.9608], ["Dutse", 11.7536, 9.3389],
    ["Gombe", 10.2897, 11.1717], ["Birnin Kebbi", 12.4500, 4.1994], ["Lafia", 8.4936, 8.5167],
    ["Jalingo", 8.8833, 11.3667], ["Umuahia", 5.5247, 7.4936], ["Awka", 6.2103, 7.0719],
    ["Yenagoa", 4.9267, 6.2675], ["Gusau", 12.1731, 6.6692], ["Osogbo", 7.7667, 4.5667],
    ["Nsukka", 6.8567, 7.3956], ["Aliade", 7.3500, 8.5333], ["Funtua", 11.5167, 7.3000],
    ["Iseyin", 7.9667, 3.6000], ["Ife", 7.4667, 4.5667], ["Ondo", 7.1000, 4.8333],
    ["Sapele", 5.8939, 5.6764], ["Effurun", 5.5500, 5.7833], ["Mubi", 10.2667, 13.2667],
    ["Gboko", 7.3236, 9.0000], ["Suleja", 9.1810, 7.1791], ["Kontagora", 10.4000, 5.4667],
    ["Wukari", 7.8500, 9.7833], ["Okene", 7.5500, 6.2333], ["Idah", 7.1167, 6.7333],
    ["Numan", 9.4667, 11.9667], ["Nguru", 12.8786, 10.4500], ["Hadejia", 12.4500, 10.0333],
    ["Argungu", 12.7458, 4.5247], ["Yauri", 10.7500, 4.7500], ["Auchi", 7.0667, 6.2667],
  ],

  // ── GHANA — regional capitals + major cities ──────────────────────────────
  ghana: [
    ["Accra", 5.6037, -0.1870, ["Osu","Labadi","East Legon","Adabraka","Madina","Tema","Kasoa","Dansoman","Tesano","Achimota","Adenta","Ashaiman"]],
    ["Kumasi", 6.6885, -1.6244], ["Tamale", 9.4034, -0.8424], ["Takoradi", 4.8845, -1.7554],
    ["Cape Coast", 5.1053, -1.2466], ["Ho", 6.6014, 0.4711], ["Koforidua", 6.0833, -0.2667],
    ["Sunyani", 7.3392, -2.3265], ["Bolgatanga", 10.7861, -0.8514], ["Wa", 10.0608, -2.5039],
    ["Sekondi", 4.9344, -1.7044], ["Tema", 5.6691, -0.0166], ["Obuasi", 6.2027, -1.6663],
    ["Techiman", 7.5833, -1.9333], ["Berekum", 7.4538, -2.5847], ["Aflao", 6.1167, 1.1833],
    ["Nungua", 5.6000, -0.0833], ["Madina", 5.6833, -0.1667], ["Kasoa", 5.5333, -0.4167],
    ["Konongo", 6.6167, -1.2167], ["Nkawkaw", 6.5500, -0.7667], ["Yendi", 9.4421, -0.0094],
    ["Bawku", 11.0500, -0.2333], ["Damongo", 9.0833, -1.8167], ["Goaso", 6.8000, -2.5167],
    ["Sefwi Wiawso", 6.2167, -2.4833], ["Nsawam", 5.8167, -0.3500], ["Hohoe", 7.1500, 0.4667],
    ["Kpando", 7.0167, 0.3000], ["Salaga", 8.5500, -0.5167], ["Saltpond", 5.2000, -1.0667],
  ],

  // ── KENYA — county capitals + major cities ────────────────────────────────
  kenya: [
    ["Nairobi", -1.2921, 36.8219, ["Westlands","Karen","Lavington","Kileleshwa","Eastleigh","Kasarani","Embakasi","Langata","Roysambu","Ruaka","Donholm"]],
    ["Mombasa", -4.0435, 39.6682], ["Kisumu", -0.0917, 34.7680], ["Nakuru", -0.3031, 36.0800],
    ["Eldoret", 0.5143, 35.2698], ["Thika", -1.0333, 37.0833], ["Malindi", -3.2175, 40.1191],
    ["Kitale", 1.0157, 35.0061], ["Garissa", -0.4569, 39.6583], ["Kakamega", 0.2842, 34.7519],
    ["Machakos", -1.5167, 37.2667], ["Meru", 0.0500, 37.6500], ["Nyeri", -0.4167, 36.9500],
    ["Kericho", -0.3667, 35.2833], ["Bungoma", 0.5667, 34.5667], ["Embu", -0.5333, 37.4500],
    ["Naivasha", -0.7167, 36.4333], ["Kitui", -1.3667, 38.0167], ["Kapenguria", 1.2333, 35.1167],
    ["Kerugoya", -0.5000, 37.2833], ["Kilifi", -3.6306, 39.8499], ["Lamu", -2.2697, 40.9020],
    ["Voi", -3.3958, 38.5564], ["Wajir", 1.7488, 40.0573], ["Mandera", 3.9389, 41.8568],
    ["Marsabit", 2.3284, 37.9897], ["Isiolo", 0.3500, 37.5833], ["Lodwar", 3.1167, 35.6000],
    ["Maralal", 1.0986, 36.6953], ["Kapsabet", 0.2031, 35.1083], ["Kabarnet", 0.4922, 35.7428],
    ["Bomet", -0.7833, 35.3500], ["Kisii", -0.6817, 34.7681], ["Migori", -1.0667, 34.4667],
    ["Homa Bay", -0.5333, 34.4500], ["Siaya", 0.0617, 34.2872], ["Busia", 0.4608, 34.1115],
    ["Vihiga", 0.0758, 34.7228], ["Murang'a", -0.7167, 37.1500], ["Othaya", -0.5500, 36.9500],
    ["Nyahururu", 0.0333, 36.3667], ["Iten", 0.6667, 35.5333], ["Kabete", -1.2500, 36.7333],
    ["Limuru", -1.1014, 36.6378], ["Ruiru", -1.1500, 36.9667], ["Athi River", -1.4500, 36.9833],
    ["Mtwapa", -3.9333, 39.7333], ["Diani", -4.3333, 39.5833], ["Watamu", -3.3500, 40.0000],
  ],

  // ── SOUTH AFRICA — cities over 50k ────────────────────────────────────────
  "south-africa": [
    ["Johannesburg", -26.2041, 28.0473, ["Sandton","Soweto","Rosebank","Randburg","Midrand","Roodepoort","Alexandra","Fourways"]],
    ["Cape Town", -33.9249, 18.4241, ["Sea Point","Camps Bay","Khayelitsha","Mitchells Plain","Bellville","Claremont","Woodstock","Observatory"]],
    ["Durban", -29.8587, 31.0218], ["Pretoria", -25.7479, 28.2293], ["Port Elizabeth", -33.9608, 25.6022],
    ["Bloemfontein", -29.0852, 26.1596], ["East London", -33.0153, 27.9116], ["Polokwane", -23.9045, 29.4689],
    ["Nelspruit", -25.4753, 30.9701], ["Kimberley", -28.7282, 24.7499], ["Pietermaritzburg", -29.6168, 30.3928],
    ["Rustenburg", -25.6672, 27.2425], ["George", -33.9648, 22.4595], ["Mthatha", -31.5889, 28.7844],
    ["Witbank", -25.8794, 29.2308], ["Klerksdorp", -26.8676, 26.6664], ["Welkom", -27.9772, 26.7338],
    ["Newcastle", -27.7574, 29.9319], ["Krugersdorp", -26.0867, 27.7711], ["Vanderbijlpark", -26.7144, 27.8347],
    ["Vereeniging", -26.6731, 27.9261], ["Worcester", -33.6469, 19.4486], ["Stellenbosch", -33.9321, 18.8602],
    ["Knysna", -34.0364, 23.0468], ["Mossel Bay", -34.1831, 22.1461], ["Paarl", -33.7274, 18.9619],
    ["Springs", -26.2497, 28.4419], ["Boksburg", -26.2125, 28.2625], ["Benoni", -26.1885, 28.3206],
    ["Germiston", -26.2178, 28.1717], ["Tembisa", -25.9963, 28.2272], ["Edenvale", -26.1419, 28.1494],
    ["Centurion", -25.8603, 28.1894], ["Ladysmith", -28.5500, 29.7833], ["Umlazi", -29.9667, 30.8833],
    ["Pinetown", -29.8194, 30.8581], ["Chatsworth", -29.9333, 30.8667], ["Phoenix", -29.6833, 30.9167],
    ["KwaMashu", -29.7333, 30.9667], ["Inanda", -29.7167, 30.9167], ["Mahikeng", -25.8650, 25.6403],
    ["Vryheid", -27.7708, 30.7906], ["Empangeni", -28.7500, 31.9000], ["Richards Bay", -28.7800, 32.0383],
    ["Uitenhage", -33.7575, 25.3958], ["Queenstown", -31.8975, 26.8753], ["King William's Town", -32.8833, 27.4000],
    ["Beaufort West", -32.3567, 22.5836], ["Upington", -28.4478, 21.2561], ["Springbok", -29.6644, 17.8869],
  ],

  // ── UGANDA — major cities ─────────────────────────────────────────────────
  uganda: [
    ["Kampala", 0.3476, 32.5825, ["Wandegeya","Bugolobi","Kololo","Ntinda","Kisaasi","Naalya","Nakawa","Mengo"]],
    ["Wakiso", 0.4040, 32.4592], ["Nansana", 0.3667, 32.5333], ["Kira", 0.4019, 32.6347],
    ["Mbale", 1.0667, 34.1667], ["Mukono", 0.3500, 32.7500], ["Gulu", 2.7747, 32.2986],
    ["Lugazi", 0.3667, 32.9333], ["Masaka", -0.3333, 31.7333], ["Kasese", 0.1833, 30.0833],
    ["Jinja", 0.4244, 33.2042], ["Mbarara", -0.6167, 30.6500], ["Entebbe", 0.0500, 32.4500],
    ["Lira", 2.2350, 32.9097], ["Soroti", 1.7147, 33.6111], ["Tororo", 0.6925, 34.1808],
    ["Kabale", -1.2500, 29.9833], ["Kitgum", 3.2783, 32.8869], ["Hoima", 1.4333, 31.3500],
    ["Iganga", 0.6167, 33.4833], ["Arua", 3.0303, 30.9111], ["Moroto", 2.5347, 34.6669],
    ["Moyo", 3.6500, 31.7167], ["Yumbe", 3.4639, 31.2469], ["Bushenyi", -0.5833, 30.2000],
    ["Rukungiri", -0.8333, 29.9333], ["Kanungu", -0.9000, 29.7833], ["Mpigi", 0.2256, 32.3225],
    ["Ntungamo", -0.8794, 30.2647], ["Kibaale", 0.8000, 31.0500], ["Pader", 2.9333, 32.7000],
    ["Apac", 1.9833, 32.5333], ["Nakasongola", 1.3000, 32.4500], ["Sembabule", -0.0833, 31.4500],
    ["Pallisa", 1.1500, 33.7167], ["Bukedea", 1.3333, 34.0500], ["Bugiri", 0.5333, 33.7500],
    ["Kamuli", 0.9333, 33.1167], ["Kayunga", 0.7000, 32.8833], ["Luwero", 0.8500, 32.4833],
  ],

  // ── CAMEROON — major cities ───────────────────────────────────────────────
  cameroon: [
    ["Yaoundé", 3.8480, 11.5021, ["Bastos","Mvog-Mbi","Briqueterie","Etoudi","Ekounou","Mendong"]],
    ["Douala", 4.0511, 9.7679, ["Akwa","Bonanjo","Bonapriso","Bonabéri","Bonamoussadi","New Bell"]],
    ["Garoua", 9.3000, 13.4000], ["Bamenda", 5.9333, 10.1667], ["Maroua", 10.5950, 14.3247],
    ["Bafoussam", 5.4781, 10.4167], ["Ngaoundéré", 7.3167, 13.5833], ["Bertoua", 4.5833, 13.6833],
    ["Kumba", 4.6333, 9.4500], ["Loum", 4.7167, 9.7333], ["Edéa", 3.8000, 10.1333],
    ["Kribi", 2.9405, 9.9088], ["Mbouda", 5.6249, 10.2531], ["Limbe", 4.0244, 9.2050],
    ["Dschang", 5.4500, 10.0667], ["Foumban", 5.7250, 10.9000], ["Buea", 4.1559, 9.2916],
    ["Tiko", 4.0833, 9.3667], ["Mutengene", 4.0833, 9.3000], ["Sangmélima", 2.9333, 11.9833],
    ["Ebolowa", 2.9000, 11.1500], ["Kousséri", 12.0769, 15.0306], ["Tibati", 6.4667, 12.6333],
    ["Banyo", 6.7500, 11.8167], ["Wum", 6.3833, 10.0667], ["Kumbo", 6.2000, 10.6667],
    ["Mamfe", 5.7667, 9.3000], ["Bafia", 4.7500, 11.2333], ["Mbalmayo", 3.5167, 11.5000],
    ["Akonolinga", 3.7667, 12.2500],
  ],

  // ── TANZANIA — major cities ───────────────────────────────────────────────
  tanzania: [
    ["Dar es Salaam", -6.7924, 39.2083, ["Kinondoni","Ilala","Temeke","Kariakoo","Mbezi","Sinza","Mwananyamala","Ubungo"]],
    ["Mwanza", -2.5167, 32.9000], ["Arusha", -3.3667, 36.6833], ["Mbeya", -8.9000, 33.4500],
    ["Morogoro", -6.8278, 37.6611], ["Tanga", -5.0667, 39.1000], ["Dodoma", -6.1722, 35.7395],
    ["Zanzibar City", -6.1639, 39.1969], ["Kigoma", -4.8769, 29.6267], ["Tabora", -5.0167, 32.8000],
    ["Songea", -10.6833, 35.6500], ["Iringa", -7.7667, 35.6833], ["Shinyanga", -3.6611, 33.4214],
    ["Musoma", -1.5000, 33.8000], ["Bukoba", -1.3333, 31.8167], ["Sumbawanga", -7.9667, 31.6167],
    ["Singida", -4.8167, 34.7500], ["Kibaha", -6.7667, 38.9167], ["Mtwara", -10.2667, 40.1833],
    ["Lindi", -10.0000, 39.7167], ["Bagamoyo", -6.4333, 38.9000], ["Korogwe", -5.1500, 38.4833],
    ["Same", -4.0667, 37.7333], ["Babati", -4.2167, 35.7500], ["Mpanda", -6.3450, 31.0628],
    ["Njombe", -9.3333, 34.7667], ["Kasulu", -4.5667, 30.1000], ["Kahama", -3.8333, 32.6000],
    ["Geita", -2.8694, 32.1714], ["Mafia", -7.9000, 39.6500], ["Kilwa", -8.9333, 39.5000],
  ],

  // ── ETHIOPIA — major cities ───────────────────────────────────────────────
  ethiopia: [
    ["Addis Ababa", 9.0227, 38.7468, ["Bole","Kazanchis","Piazza","Megenagna","Merkato","Sarbet","Kaliti","Lebu"]],
    ["Dire Dawa", 9.5907, 41.8662], ["Mekele", 13.4967, 39.4753], ["Gondar", 12.6000, 37.4667],
    ["Bahir Dar", 11.6000, 37.3833], ["Hawassa", 7.0500, 38.4667], ["Adama", 8.5500, 39.2667],
    ["Jimma", 7.6667, 36.8333], ["Dessie", 11.1333, 39.6333], ["Bishoftu", 8.7522, 38.9756],
    ["Sodo", 6.8500, 37.7500], ["Shashamane", 7.2000, 38.6000], ["Arba Minch", 6.0333, 37.5500],
    ["Hosaena", 7.5500, 37.8500], ["Harar", 9.3119, 42.1183], ["Dilla", 6.4117, 38.3094],
    ["Nekemte", 9.0875, 36.5500], ["Debre Birhan", 9.6803, 39.5325], ["Asella", 7.9472, 39.1289],
    ["Debre Markos", 10.3500, 37.7167], ["Kombolcha", 11.0833, 39.7333], ["Adigrat", 14.2767, 39.4622],
    ["Axum", 14.1267, 38.7239], ["Wukro", 13.7833, 39.6000], ["Ambo", 8.9870, 37.8540],
    ["Robe", 7.1167, 40.0000], ["Goba", 7.0167, 39.9833], ["Gambela", 8.2500, 34.5833],
    ["Jijiga", 9.3500, 42.8000], ["Asaita", 11.5667, 41.4333], ["Semera", 11.7903, 41.0008],
  ],

  // ── UK — all cities over 50k population ───────────────────────────────────
  uk: [
    ["London", 51.5074, -0.1278, ["Peckham","Brixton","Woolwich","Croydon","Tottenham","Stratford","Lewisham","Hackney","Ilford","Thornton Heath","Camberwell","Walworth","Battersea","Wandsworth","Streatham","Catford","Greenwich","Bermondsey","Deptford","New Cross","Plumstead","Mile End","Whitechapel","Dalston","Stoke Newington","Finsbury Park","Wood Green","Edmonton","Enfield","Wembley","Harrow","Southall","Hounslow","Ealing","Acton","Shepherd's Bush","Notting Hill","Earl's Court","Putney","Clapham","Tooting","Mitcham","Sutton","Bromley","Beckenham","Catford","Forest Hill","Sydenham","Crystal Palace"]],
    ["Birmingham", 52.4862, -1.8904], ["Manchester", 53.4808, -2.2426], ["Glasgow", 55.8642, -4.2518],
    ["Leeds", 53.8008, -1.5491], ["Liverpool", 53.4084, -2.9916], ["Newcastle upon Tyne", 54.9783, -1.6178],
    ["Sheffield", 53.3811, -1.4701], ["Bristol", 51.4545, -2.5879], ["Belfast", 54.5973, -5.9301],
    ["Leicester", 52.6369, -1.1398], ["Edinburgh", 55.9533, -3.1883], ["Coventry", 52.4068, -1.5197],
    ["Bradford", 53.7960, -1.7594], ["Cardiff", 51.4816, -3.1791], ["Nottingham", 52.9548, -1.1581],
    ["Kingston upon Hull", 53.7457, -0.3367], ["Stoke-on-Trent", 53.0027, -2.1794], ["Wolverhampton", 52.5879, -2.1284],
    ["Plymouth", 50.3755, -4.1427], ["Derby", 52.9225, -1.4746], ["Southampton", 50.9097, -1.4044],
    ["Aberdeen", 57.1497, -2.0943], ["Portsmouth", 50.8198, -1.0880], ["Brighton", 50.8225, -0.1372],
    ["Reading", 51.4543, -0.9781], ["Northampton", 52.2405, -0.9027], ["Luton", 51.8787, -0.4200],
    ["Bolton", 53.5780, -2.4291], ["Bournemouth", 50.7192, -1.8808],
    ["Norwich", 52.6309, 1.2974], ["Swindon", 51.5557, -1.7797], ["Swansea", 51.6214, -3.9436],
    ["Milton Keynes", 52.0406, -0.7594], ["Southend-on-Sea", 51.5459, 0.7077], ["Middlesbrough", 54.5742, -1.2349],
    ["Sunderland", 54.9061, -1.3812], ["Warrington", 53.3900, -2.5970], ["Huddersfield", 53.6450, -1.7830],
    ["Slough", 51.5095, -0.5954], ["Oxford", 51.7520, -1.2577], ["York", 53.9600, -1.0873],
    ["Poole", 50.7192, -1.9872], ["Telford", 52.6766, -2.4470], ["Ipswich", 52.0567, 1.1482],
    ["West Bromwich", 52.5187, -1.9945], ["Walsall", 52.5862, -2.0103], ["Blackpool", 53.8175, -3.0357],
    ["Stockport", 53.4084, -2.1494], ["Cambridge", 52.2053, 0.1218], ["Doncaster", 53.5228, -1.1285],
    ["Rotherham", 53.4302, -1.3568], ["Preston", 53.7632, -2.7031], ["Newport", 51.5842, -2.9977],
    ["Watford", 51.6565, -0.3903], ["Exeter", 50.7184, -3.5339], ["Gloucester", 51.8642, -2.2380],
    ["Bath", 51.3811, -2.3590], ["Worcester", 52.1936, -2.2215], ["Crawley", 51.1092, -0.1872],
    ["Lincoln", 53.2307, -0.5406], ["Grimsby", 53.5658, -0.0793], ["Halifax", 53.7197, -1.8593],
    ["Eastbourne", 50.7687, 0.2900], ["Sutton Coldfield", 52.5712, -1.8246], ["Maidstone", 51.2720, 0.5184],
    ["Wakefield", 53.6831, -1.4925], ["Burnley", 53.7898, -2.2483], ["Hastings", 50.8543, 0.5731],
    ["Dundee", 56.4620, -2.9707], ["Inverness", 57.4778, -4.2247], ["Wrexham", 53.0428, -2.9926],
    ["Mansfield", 53.1413, -1.1989], ["Stevenage", 51.9024, -0.2032], ["High Wycombe", 51.6285, -0.7493],
    ["Basildon", 51.5765, 0.4794], ["Colchester", 51.8959, 0.8919], ["Chelmsford", 51.7356, 0.4685],
    ["Salford", 53.4875, -2.2901], ["Oldham", 53.5409, -2.1114], ["Rochdale", 53.6097, -2.1561],
    ["Tamworth", 52.6334, -1.6951], ["Hereford", 52.0567, -2.7160], ["Carlisle", 54.8924, -2.9320],
    ["Chester", 53.1934, -2.8931], ["Lancaster", 54.0466, -2.8007], ["Canterbury", 51.2802, 1.0789],
    ["Salisbury", 51.0688, -1.7945], ["Truro", 50.2632, -5.0510], ["St Albans", 51.7510, -0.3360],
  ],

  // ── USA — cities with significant African diaspora ────────────────────────
  usa: [
    ["New York", 40.7128, -74.0060, ["Harlem","Brooklyn","Bronx","Queens","Bedford-Stuyvesant","Flatbush","Crown Heights","East Flatbush","Bushwick","Jamaica","Rosedale","Far Rockaway"]],
    ["Atlanta", 33.7490, -84.3880, ["Buckhead","Midtown","Decatur","College Park","East Point","Stone Mountain","Lithonia","Stonecrest","South Fulton","Riverdale"]],
    ["Houston", 29.7604, -95.3698, ["Alief","Sugar Land","Missouri City","Pearland","Katy","Cypress","Spring","The Woodlands"]],
    ["Washington", 38.9072, -77.0369, ["Silver Spring","Hyattsville","Largo","Bowie","Capitol Heights","Fort Washington","Adams Morgan","U Street","Petworth"]],
    ["Chicago", 41.8781, -87.6298, ["Hyde Park","Bronzeville","Englewood","South Shore","Austin","Roseland","Pilsen","Logan Square","Rogers Park"]],
    ["Dallas", 32.7767, -96.7970], ["Los Angeles", 34.0522, -118.2437, ["Inglewood","Leimert Park","Crenshaw","Compton","Watts","Carson","Long Beach","South LA"]],
    ["Philadelphia", 39.9526, -75.1652], ["Minneapolis", 44.9778, -93.2650], ["Boston", 42.3601, -71.0589],
    ["San Francisco", 37.7749, -122.4194], ["Detroit", 42.3314, -83.0458], ["Memphis", 35.1495, -90.0490],
    ["Baltimore", 39.2904, -76.6122], ["Charlotte", 35.2271, -80.8431], ["Indianapolis", 39.7684, -86.1581],
    ["Columbus", 39.9612, -82.9988], ["Jacksonville", 30.3322, -81.6557], ["Seattle", 47.6062, -122.3321],
    ["San Antonio", 29.4241, -98.4936], ["Austin", 30.2672, -97.7431], ["Fort Worth", 32.7555, -97.3308],
    ["Denver", 39.7392, -104.9903], ["Nashville", 36.1627, -86.7816], ["Oklahoma City", 35.4676, -97.5164],
    ["Las Vegas", 36.1699, -115.1398], ["Portland", 45.5152, -122.6784], ["Milwaukee", 43.0389, -87.9065],
    ["Albuquerque", 35.0844, -106.6504], ["Tucson", 32.2226, -110.9747], ["Fresno", 36.7378, -119.7871],
    ["Sacramento", 38.5816, -121.4944], ["Mesa", 33.4152, -111.8315], ["Kansas City", 39.0997, -94.5786],
    ["Long Beach", 33.7701, -118.1937], ["Cleveland", 41.4993, -81.6944], ["Miami", 25.7617, -80.1918],
    ["Raleigh", 35.7796, -78.6382], ["Omaha", 41.2565, -95.9345], ["Virginia Beach", 36.8529, -75.9780],
    ["Oakland", 37.8044, -122.2712], ["Tulsa", 36.1539, -95.9928], ["New Orleans", 29.9511, -90.0715],
    ["Wichita", 37.6872, -97.3301], ["Arlington", 32.7357, -97.1081], ["Tampa", 27.9506, -82.4572],
    ["St. Louis", 38.6270, -90.1994], ["Honolulu", 21.3069, -157.8583], ["Anchorage", 61.2181, -149.9003],
    ["Cincinnati", 39.1031, -84.5120], ["Pittsburgh", 40.4406, -79.9959], ["Greensboro", 36.0726, -79.7920],
    ["St. Paul", 44.9537, -93.0900], ["Stockton", 37.9577, -121.2908], ["Lincoln", 40.8136, -96.7026],
    ["Plano", 33.0198, -96.6989], ["Newark", 40.7357, -74.1724], ["Buffalo", 42.8864, -78.8784],
    ["Henderson", 36.0395, -114.9817], ["Fort Wayne", 41.0793, -85.1394], ["Jersey City", 40.7178, -74.0431],
    ["Chula Vista", 32.6401, -117.0842], ["Norfolk", 36.8508, -76.2859], ["Madison", 43.0731, -89.4012],
    ["Lubbock", 33.5779, -101.8552], ["Toledo", 41.6528, -83.5379], ["Reno", 39.5296, -119.8138],
    ["St. Petersburg", 27.7676, -82.6403], ["Laredo", 27.5306, -99.4803], ["Scottsdale", 33.4942, -111.9261],
    ["Chandler", 33.3062, -111.8413], ["Glendale", 33.5387, -112.1860], ["Birmingham", 33.5186, -86.8104],
    ["Salt Lake City", 40.7608, -111.8910], ["Tacoma", 47.2529, -122.4443], ["Riverside", 33.9806, -117.3755],
  ],

  // ── CANADA — major cities ─────────────────────────────────────────────────
  canada: [
    ["Toronto", 43.6532, -79.3832, ["Scarborough","North York","Etobicoke","Brampton","Mississauga","Markham","Vaughan","Pickering","Ajax","Richmond Hill","Little Jamaica","Eglinton West","Jane and Finch","Rexdale","Malvern"]],
    ["Montreal", 45.5017, -73.5673, ["Côte-des-Neiges","Saint-Michel","Montréal-Nord","Saint-Léonard","Pierrefonds","Anjou","Verdun","NDG"]],
    ["Calgary", 51.0447, -114.0719], ["Vancouver", 49.2827, -123.1207, ["Surrey","Burnaby","Richmond","New Westminster","Coquitlam","Delta","Langley","North Vancouver"]],
    ["Ottawa", 45.4215, -75.6972], ["Edmonton", 53.5461, -113.4938], ["Mississauga", 43.5890, -79.6441],
    ["Winnipeg", 49.8951, -97.1384], ["Quebec City", 46.8139, -71.2080], ["Hamilton", 43.2557, -79.8711],
    ["Brampton", 43.7315, -79.7624], ["Surrey", 49.1913, -122.8490], ["Laval", 45.6066, -73.7124],
    ["Halifax", 44.6488, -63.5752], ["London", 42.9849, -81.2453], ["Markham", 43.8561, -79.3370],
    ["Vaughan", 43.8361, -79.4982], ["Gatineau", 45.4765, -75.7013], ["Saskatoon", 52.1332, -106.6700],
    ["Longueuil", 45.5371, -73.5113], ["Burnaby", 49.2488, -122.9805], ["Regina", 50.4452, -104.6189],
    ["Richmond", 49.1666, -123.1336], ["Richmond Hill", 43.8828, -79.4403], ["Oakville", 43.4675, -79.6877],
    ["Burlington", 43.3255, -79.7990], ["Greater Sudbury", 46.4917, -80.9930], ["Sherbrooke", 45.4042, -71.8929],
    ["Oshawa", 43.8971, -78.8658], ["Saguenay", 48.4280, -71.0686], ["Lévis", 46.8064, -71.1779],
    ["Barrie", 44.3894, -79.6903], ["Abbotsford", 49.0504, -122.3045], ["Coquitlam", 49.2838, -122.7932],
    ["Trois-Rivières", 46.3432, -72.5432], ["St. Catharines", 43.1594, -79.2469], ["Guelph", 43.5448, -80.2482],
    ["Cambridge", 43.3601, -80.3127], ["Whitby", 43.8975, -78.9429], ["Kelowna", 49.8880, -119.4960],
    ["Kingston", 44.2312, -76.4860], ["Ajax", 43.8509, -79.0204], ["Langley", 49.1044, -122.6603],
    ["Saanich", 48.4843, -123.3812], ["Terrebonne", 45.6951, -73.6471], ["Milton", 43.5183, -79.8774],
    ["St. John's", 47.5615, -52.7126], ["Thunder Bay", 48.3809, -89.2477], ["Waterloo", 43.4643, -80.5204],
    ["Delta", 49.0847, -123.0586], ["Chatham-Kent", 42.4048, -82.1910], ["Red Deer", 52.2681, -113.8112],
    ["Strathcona County", 53.5402, -113.2098], ["Brantford", 43.1394, -80.2644], ["Cape Breton", 46.0922, -60.1828],
  ],
};

/* ── Helpers ────────────────────────────────────────────────────────────── */

export function slugify(name) {
  return name
    .toString()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .toLowerCase()
    .replace(/['"`]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getAllCities(countrySlug) {
  const rows = CITIES_BY_COUNTRY[countrySlug] || [];
  return rows.map(([name, lat, lng, areas]) => ({
    slug: slugify(name),
    name,
    lat,
    lng,
    areas: (areas || []).map((a) => ({ slug: slugify(a), name: a })),
  }));
}

export function findCityExtended(countrySlug, citySlug) {
  return getAllCities(countrySlug).find((c) => c.slug === citySlug) || null;
}

export function findAreaExtended(countrySlug, citySlug, areaSlug) {
  const city = findCityExtended(countrySlug, citySlug);
  if (!city) return null;
  return city.areas.find((a) => a.slug === areaSlug) || null;
}

// Flattened list of EVERY city for the global map (~500 pins)
export function getAllCitiesGlobal() {
  const out = [];
  for (const [countrySlug, rows] of Object.entries(CITIES_BY_COUNTRY)) {
    for (const [name, lat, lng] of rows) {
      out.push({ countrySlug, citySlug: slugify(name), name, lat, lng });
    }
  }
  return out;
}
